import ModuleProvider from './providers/ModuleProvider'
import Main from './Main'

const OSRoomArtworkV2 = (props) => (
  <ModuleProvider props={props}>
    <Main />
  </ModuleProvider>
)

export default OSRoomArtworkV2
